import React from 'react';


export default function nl2br(text) {
    const res = [];
    text.split('\n').forEach((x, i) => {
        if (i !== 0) {
            res.push(<br key={`br-${i}`} />); // eslint-disable-line react/no-array-index-key
        }

        res.push(x);
    });

    return res;
}

export const gettext = text => window.gettext(text);
export const ngettext = (...args) => window.ngettext(...args);



// WEBPACK FOOTER //
// ./src/utils/text.js